import { render, staticRenderFns } from "./CompaniesComponent.vue?vue&type=template&id=0802154e&scoped=true&"
import script from "./CompaniesComponent.vue?vue&type=script&lang=js&"
export * from "./CompaniesComponent.vue?vue&type=script&lang=js&"
import style0 from "./CompaniesComponent.vue?vue&type=style&index=0&id=0802154e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0802154e",
  null
  
)

export default component.exports